import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import SEO from '@c/seo'
import SiteHeader from './site-header'
import SiteMenu from './site-menu'
import SiteFooter from './site-footer'

const Layout = ({ children, mainClass, locale, seo }) => {
  return (
    <>
      <a href="#site-main" id="skip-link">
        Skip to Main Content
      </a>
      <SiteHeader locale={locale} links={seo?.link} />
      <SiteMenu locale={locale} links={seo?.link} />
      <main
        className={cn('SiteMain pt-120 pt-lg-160 pb-50 pb-lg-50', mainClass)}
        id="site-main"
        role="main"
      >
        {seo && <SEO locale={locale} {...seo} />}
        {children}
      </main>
      <SiteFooter locale={locale} />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
